import React from 'react';
import {SidebarMenuSections} from 'components/sidebar/stores/sidebarMenu';

const SidebarMenuContext = React.createContext<SidebarMenuSections | ''>('');

export default SidebarMenuContext;
